<template>
	<div class="pages" :class="{ 'is-h5': isH5 }">
		<!-- 快捷栏 -->
		<shortcut-bar class="shortcut-bar page-header" />
		<div class="page-header-placeholder"></div>

		<!-- PC 布局：保持原样 -->
		<el-container v-if="!isH5">
			<el-aside width="240px">
				<div class="leftList">
					<ul class="">
						<div class="leftList-top">
							<img src="../../../static/images/icon/icon23.png" alt="">
							<span class="margin-left-12">{{ $t('全部功能') }}</span>
						</div>
						<li v-for="(item, index) in itemNav" class :class="{ active: isActiveBar(item.index) }"
							:key="index" @click="selectItem(item)">
							{{ item.title }}
						</li>
					</ul>
				</div>
			</el-aside>
			<el-main width="1040px" style="margin: 0;">
				<div class="content">
					<router-view @fix-header="fixHeader"></router-view>
				</div>
			</el-main>
		</el-container>

		<!-- H5 独立布局 -->
		<div v-else class="h5-user-center">
			<div class="h5-nav">
				<div v-for="(item, index) in itemNav" :key="index" class="h5-nav-item"
					:class="{ active: isActiveBar(item.index) }" @click="selectItem(item)">
					{{ item.title }}
				</div>
			</div>
			<div class="h5-body">
				<router-view @fix-header="fixHeader"></router-view>
			</div>
		</div>

		<!-- 左侧悬浮框 -->
		<div v-if="!isH5">
			<leftSuspension />
		</div>

		<!-- 退出登录弹窗 -->
		<popup :show="show" :content="$t('确定退出登录吗？')" @close="show = false" @confirm="onConfirm"></popup>

		<footer-bar></footer-bar>
	</div>
</template>

<style scoped>
	div /deep/ .el-main::-webkit-scrollbar {
		display: none;
		/* Chrome, Safari */
	}

	div /deep/ .el-aside::-webkit-scrollbar {
		display: none;
		/* Chrome, Safari */
	}
</style>

<script>
	import ShortcutBar from '@/components/ShortcutBar'
	import leftSuspension from "@/components/leftSuspension.vue";
	import popup from '@/components/popup.vue';
	import footerBar from '@/components/footerBar';

	export default {
		name: 'UserCenter',
		components: {
			'footer-bar': footerBar,
			'shortcut-bar': ShortcutBar,
			leftSuspension,
			popup,
		},
		data() {
			return {
				isH5: typeof window !== 'undefined' && window.innerWidth < 768,
				isHeaderFixed: false,
				currentActiveNavIndex: 0,
				itemNav: [
					{
						index: 0,
						title: this.$t('我的订单'),
						name: 'MyOrder2'
					},
					{
						index: 1,
						title: this.$t('我的购物车'),
						name: 'ShoppingCart'
					},
					{
						index: 2,
						title: this.$t('退款/售后'),
						name: 'AfterSale'
					},
					{
						index: 3,
						title: this.$t('我的收藏'),
						name: 'MyCollection'
					},
					{
						index: 4,
						title: this.$t('我的足迹'),
						name: 'Myfootprint'
					},
					{
						index: 9,
						title: this.$t('我的互动'),
						name: 'interaction'
					},
					{
						index: 5,
						title: this.$t('收货地址'),
						name: 'Receivingaddress'
					},
					{
						index: 6,
						title: this.$t('个人资料'),
						name: 'Personaldata'
					},
					{
						index: 7,
						title: this.$t('安全设置'),
						name: 'Securitysetting'
					},
					{
						index: 8,
						title: this.$t('退出登录'),
						name: ''
					},
				],
				show: false,//弹窗
			}
		},
		computed: {

		},
		watch: {
			'$route'(to, from) {
				if (to.path !== from.path) {
					const userType = to.params.type;
					this.currentActiveNavIndex = userType;
				}
			}
		},
		created() {
			this.updateIsH5();
		},
		mounted() {
			const userType = this.$route.params.type;
			this.currentActiveNavIndex = userType;
			this.autoFixHeader();
			this.updateIsH5();
			window.addEventListener('resize', this.updateIsH5);
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateIsH5);
		},
		methods: {
			updateIsH5() {
				this.isH5 = window.innerWidth < 768;
			},
			/**弹窗确认 */
			onConfirm() {
				this.$cookies.remove('user_info');
				this.$cookies.remove('user_token');
				this.show = false
				this.$message.error(this.$t('已退出'));

				setTimeout(res => {
					this.$router.push({ name: 'Home' });
				}, 1000)
			},
			isActiveBar: function (index) {
				return index == this.currentActiveNavIndex;
			},
			/**左侧列表点击*/
			selectItem: function (item) {
				if (item.index == 8) {
					this.show = true
				} else {
					this.$router.push({ name: item.name, params: { type: item.index } });
					this.autoFixHeader();
				}
			},
			fixHeader: function () {
				if (window.pageYOffset < 30) {
					this.isHeaderFixed = false;
				} else {
					this.isHeaderFixed = true;
				}
			},
			autoFixHeader: function () {
				var fixHeader = this.fixHeader;
				window.onscroll = function () {
					fixHeader();
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	.page-header {
		z-index: 999;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.page-header-placeholder {
		height: 56px;
	}

	.el-container {
		width: calc(240px + 1040px);
		margin: 24px auto 0;
		background-color: #FFFFFF;
		height: calc(100vh - 80px);
		box-sizing: border-box;
	}

	.el-aside {
		.leftList {
			width: 200px;
			background: #FFFFFF;
			box-sizing: border-box;
			box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
			margin: 40px 20px 0;
			border-radius: 8px;

			.leftList-top {
				display: flex;
				align-items: center;
				padding: 24px 20px;

				img {
					width: 30px;
					height: 30px;
				}
			}

			ul {
				li {
					padding: 12px 20px;
					font-size: 16px;
					cursor: pointer;
					border-bottom: 1px solid #EAEBEF;
					border-radius: 5px;
				}

				.active {
					background: #000000;
					color: #FFFFFF;
				}
			}
		}
	}

	.el-main {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.h5-user-center {
		width: 100%;
		min-height: calc(100vh - 56px);
		background: #f5f6f8;
	}

	.h5-nav {
		position: sticky;
		top: 56px;
		z-index: 20;
		display: flex;
		overflow-x: auto;
		-webkit-overflow-scrolling: touch;
		background: #fff;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}
	}

	.h5-nav-item {
		flex-shrink: 0;
		padding: 12px 16px;
		font-size: 14px;
		white-space: nowrap;
		color: #333;
	}

	.h5-nav-item.active {
		background: #000;
		color: #fff;
	}

	.h5-body {
		padding: 12px;
		width: 100%;
		box-sizing: border-box;
		overflow-x: hidden;
	}

	@media (max-width: 767px) {
		.pages {
			overflow-x: hidden;
			width: 100%;
		}

		.page-header {
			padding-top: env(safe-area-inset-top, 0px);
		}

		.page-header-placeholder {
			height: calc(56px + env(safe-area-inset-top, 0px));
		}

		.h5-nav {
			top: calc(56px + env(safe-area-inset-top, 0px));
		}

		.h5-user-center {
			min-height: calc(100vh - 56px - env(safe-area-inset-top, 0px));
		}
	}
</style>

<!-- H5 子页强制覆盖：不走 scoped，避免打不进子组件 -->
<style lang="scss">
	.pages.is-h5 {
		width: 100%;
		max-width: 100%;
		overflow-x: hidden;
		background: #f5f6f8;

		.h5-body {
			.my-order,
			.pages,
			.user-center-home,
			.my-Personaldata,
			.my-address,
			.my-security-setting,
			.my-interaction,
			.my-footprint,
			.my-collection,
			.user-center-temp {
				width: 100% !important;
				max-width: 100% !important;
				min-width: 0 !important;
				height: auto !important;
				min-height: 0 !important;
				margin: 0 !important;
				padding: 12px !important;
				box-sizing: border-box;
				overflow: visible !important;
				box-shadow: none;
			}

			.pc-table {
				display: none !important;
			}

			.h5-order-list {
				display: block !important;
			}

			.el-table {
				width: 100% !important;
			}

			.el-pagination {
				white-space: nowrap;
				overflow-x: auto;
				margin: 0 auto;
				justify-content: center;
			}

			img {
				max-width: 100%;
			}

			/* 个人资料：去掉 PC 左侧大留白 */
			.my-Personaldata {
				padding: 16px 12px 24px !important;
			}

			.my-Personaldata .form {
				width: 100% !important;
			}

			.my-security-setting {
				padding: 16px 12px 24px !important;
			}

			.my-security-setting .security-content {
				align-items: stretch !important;
				width: 100% !important;
			}

			.my-security-setting .btn {
				width: 100% !important;
				margin-left: 0 !important;
			}

			.my-address {
				padding: 16px 12px 24px !important;
				background: transparent !important;
			}

			.my-address .h5-address-list {
				display: block !important;
			}

			.education {
				width: 100% !important;
			}

			/* 购物车 */
			.pages {
				display: block !important;
			}

			.pages > div[style] {
				width: 100% !important;
				margin: 0 0 12px !important;
				padding: 16px 12px !important;
				box-sizing: border-box;
			}

			.settlement {
				position: static !important;
				width: 100% !important;
				right: auto !important;
				top: auto !important;
			}

			.product-item {
				flex-wrap: wrap;
			}

			.product-item > div[style] {
				width: calc(100% - 140px) !important;
				height: auto !important;
			}

			.product-quantity {
				margin-left: 32px !important;
			}

			.operate-box {
				margin-left: auto !important;
			}

			/* 首页卡片绝对定位 */
			.user-center-home .profile,
			.user-center-home .record {
				width: 100% !important;
				height: auto !important;
				position: static !important;
			}

			.user-center-home .profile .user,
			.user-center-home .profile .wallet,
			.user-center-home .record > div,
			.user-center-home .record .my-order,
			.user-center-home .record .my-interest {
				position: static !important;
				width: 100% !important;
				height: auto !important;
				left: auto !important;
				margin-bottom: 12px;
			}

			.user-center-home .profile .wallet div:nth-child(n+2) {
				width: 33.33% !important;
				padding: 16px 8px !important;
				height: auto !important;
			}

			.user-center-home .record .my-order > div:nth-child(n+2) {
				width: 20% !important;
				height: auto !important;
			}

			.user-center-home .record .my-order > div:nth-child(n+2) .order-icon {
				left: 50% !important;
				margin-left: -30px;
			}

			.user-center-home .record .my-interest > div:nth-child(n+2) {
				width: 33.33% !important;
				height: auto !important;
				padding: 16px 8px 24px !important;
			}

			/* 收藏 / 足迹 */
			.card {
				height: auto !important;
				overflow: visible !important;
			}

			.list {
				padding: 0 !important;
			}

			.list .list-box {
				width: calc(50% - 6px) !important;
				margin-right: 0 !important;
				margin-top: 12px !important;
			}

			.list .list-box .img-container {
				height: auto !important;
				aspect-ratio: 1;
			}

			/* 地址弹窗 */
			.pop .pop-box {
				width: calc(100vw - 32px) !important;
				max-width: 100% !important;
				box-sizing: border-box;
			}

			.my-address .address-pop.is-h5 .address-pop-box {
				width: 100% !important;
				max-width: 100% !important;
			}

			/* 互动 */
			.my-interaction {
				padding: 16px 12px 24px !important;
				background: transparent !important;
			}

			.my-interaction .h5-interaction-grid {
				display: grid !important;
			}

			.my-footprint {
				padding: 16px 12px 24px !important;
				background: transparent !important;
			}

			.my-footprint .list {
				display: grid !important;
				grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
				gap: 10px !important;
			}

			.my-footprint .list .list-box {
				width: 100% !important;
				margin-top: 0 !important;
			}

			.my-collection {
				padding: 16px 12px 24px !important;
				background: transparent !important;
			}

			.my-collection .list {
				display: grid !important;
				grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
				gap: 10px !important;
			}

			.my-collection .list .list-box {
				width: 100% !important;
				margin-top: 0 !important;
			}

			.user-center-temp .content {
				width: 100% !important;
			}

			.amend .amend-box {
				flex-direction: column;
				align-items: stretch !important;
			}

			.amend .amend-box-ipt,
			.amend .amend-box-right {
				width: 100% !important;
			}

			.btn {
				margin-left: 0 !important;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/view/my/UserCenter.vue